import { h } from 'preact';
import PureComponent from './PureComponent';
import getJSON from '../utils/get-json';
import { select, geoAlbersUsa, scaleLinear } from "d3"

import DistrictMapMini from './DistrictMapMini';
import DistrictMapZoomed from './DistrictMapZoomed';
import DistrictMapScaleBar from './DistrictMapScaleBar';
import DistrictMapLegend from './DistrictMapLegend';

const P = {
  map_padding: 32.25,
  markerSize: {w: 20, h: 30},
  legend: [
    {color: "#2569C4", text: "+100 Biden", position: -100, style: "color: #2569C4"},
    {color: "#333333", text: "Tie", position: 0, style: "color: #333333"},
    {color: "#EF564A", text: "+100 Trump", position: 100, style: "color: #EF564A"},
  ],
  mapWidth: 215
}

class DistrictMap extends PureComponent {
  constructor() {
    super();

    this.state = {
      width: null,
      height: 450,
      mapWidth: null,
      geometry: null,
      isLoading: false,
      simplified_geo: null,
      breakPoint: 544,
      pointRadius: 5,
      projection: null
    };
  }

  setProjection(width, padding, geometry) {
    const projection = geoAlbersUsa()
    .fitExtent([[padding, padding], [width - padding, width - padding]], geometry.geometry_simple);

    this.setState({
      projection: projection
    })
  }

  fetchDistrict() {
    this.setState({ isLoading: false });
    const { slug, district, width } = this.props;

    const padding = width / 2 - width / 2 / Math.sqrt(2);

    // We first get the geometry (borders) and simplified geometries (borders for static images) for the previous 2020 districts
    getJSON(
      `${process.env.PUBLIC_PATH}api/${slug}-2020/${district}.json`
    ).then(geometry => {
      this.setProjection(width, padding, geometry);

      this.setState({
        geometry: geometry,
        isLoading: true,
        simplified_geo: geometry['geometry_simple'],
      });
    });
  }

  componentDidMount() {
    this.fetchDistrict();
  }

  componentDidUpdate(prevProps) {
    if(this.props != prevProps) {
      const { width } = this.props;
      const { geometry } = this.state;
      const padding = width / 2 - width / 2 / Math.sqrt(2);

      this.setProjection(width, padding, geometry);

      if (this.props.district !== prevProps.district) {
        this.fetchDistrict();
      }
    }
  }

  render() {
    const { point, district, slug, width } = this.props;
    const { geometry, isLoading, projection } = this.state;

    const id = `district-map__${slug}__${district}`;

    if (!isLoading) return null;

    return (
      <div id={id} class="district-map">
        <div class="seat__subtitle">
          How this district voted in the 2020 presidential election
        </div>
        <div class="district-map__legend">
          <DistrictMapLegend
              geometry={geometry}
              width={width}
            />
          <div class="district-map__legend__text">
            {P.legend.map(l => (
              <span style={l.style}>{l.text}</span>
            ))}
          </div>
        </div>
        <div class="district-map__container">
          <DistrictMapZoomed
            geometry={geometry}
            width={width}
            coordinates={point}
            projection={projection}
          />
          <div class="district-map__bottom">
            <DistrictMapMini
              geometry={geometry}
            />
            <DistrictMapScaleBar
              projection={projection}
              geometry={geometry}
              width={width}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default DistrictMap;